import React from "react";
import { Typography } from "antd";
import { ACCENT, ACCENT_DARK, THUMB_W } from "../constants/quotationConstants";
import ElementContent from "./ElementContent";

const { Text } = Typography;

export default function TemplateThumb({ tpl, active, onClick }) {
  const designW = 794,
    designH = 1123;
  const thumbH = Math.round(THUMB_W * (designH / designW));
  const scale = THUMB_W / designW;
  const elements = tpl.elements;

  return (
    <div onClick={onClick} style={{ cursor: "pointer", marginBottom: 16, display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div
        style={{
          width: THUMB_W,
          height: thumbH,
          background: "#fff",
          position: "relative",
          overflow: "hidden",
          border: `2px solid ${active ? ACCENT : "#E4E8EE"}`,
          borderRadius: 4,
          boxShadow: active ? `0 0 0 3px rgba(24,95,165,0.15)` : "0 1px 4px rgba(20,30,50,0.12)",
          transition: "box-shadow 120ms, border-color 120ms",
        }}
      >
        {elements.length === 0 ? (
          <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, color: "#C7CFDA" }}>
            empty
          </div>
        ) : (
          <div style={{ position: "absolute", top: 0, left: 0, width: designW, height: designH, transform: `scale(${scale})`, transformOrigin: "top left", pointerEvents: "none" }}>
            {elements.map((el, i) => (
              <div key={el.id || i} style={{ position: "absolute", left: el.x, top: el.y, width: el.w, height: el.h, boxSizing: "border-box" }}>
                <ElementContent el={el} />
              </div>
            ))}
          </div>
        )}
      </div>
      <Text style={{ fontSize: 11, marginTop: 6, textAlign: "center", color: active ? ACCENT_DARK : "#5B6673", fontWeight: active ? 700 : 500 }}>
        {tpl.label}
      </Text>
    </div>
  );
}
